.section {
  display: flex;
  align-items: center;
}
.sectionV2 {
  align-items: center;
}

.label {
  margin-left: 8px;
  font-family: Montserrat;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: right;
  vertical-align: middle;
  color: var(--blue-01)

}

.date {
  white-space: nowrap;
}